export const SITE_LOCATIONS = {
	ADD_TO_PROJECT: 'AddToProject',
	MENU: 'Menu',
	CONFIGURATOR: 'Configurator',
	PROJECT_DETAILS: 'ProjectDetails',
	MY_PROJECTS: 'MyProjects',
	PRODUCT_SHEET: 'ProductSheet'
}
